export default __webpack_public_path__ + "static/media/ship.67fbdd1c.png";